export default __webpack_public_path__ + "static/media/logo-xl.5bfe2260.jpg";